import { Button, Icon } from "antd";
import { Link } from "react-router-dom";
import React from "react";
import SwiperCore, { Autoplay, Navigation, Pagination } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper.less";
import "./style.less";
import "swiper/components/navigation/navigation.less";
// import img1 from "../../assets/img/img_shouye_jishu_01.png";
// import img2 from "../../assets/img/img_shouye_jishu_02.png";
// import img3 from "../../assets/img/img_shouye_jishu_03.png";
// import img4 from "../../assets/img/img_shouye_jishu_04.png";
SwiperCore.use([Autoplay, Navigation, Pagination]);
const config = {
  spaceBetween: 80,
  autoplay: {
    //自动播放，注意：直接给autoplay:true的话，在点击之后不能再自动播放了
    delay: 2500,
    disableoninteraction: true, //户操作swiper之后，是否禁止autoplay。默认为true：停止。
  },
  loop: true,
  pagination: {
    clickable: true,
  },
  autoplaydisableoninteraction: 'false',
  slidesPerView: "auto",
  centeredSlides: true,
};
class Simplelunbo extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      current: 0,
    };
  }
  componentDidMount() {
    // 热门推荐 导航
    // let galleryThumbs = new Swiper(".swiper-container", {
    //   loop: true, //设置 active slide 居中后，会有左右留白现象，添加此会让未尾的导航补齐前后空白
    //   slideToClickedSlide: true, //设置为true则点击slide会过渡到这个slide。
    //   slidesPerView: 'auto',
    //   centeredSlides: true, //设定为true时，active slide会居中，而不是默认状态下的居左。
    //   spaceBetween: 20,
    //   slidesOffsetBefore: 0,
    //   slidesOffsetAfter: 0,
    //   autoplay:200,
    // });

    const p = document.querySelectorAll(".swiper-pagination-bullet");
    //  p.map((item,index) => {
    //    item.innerHtml = `<div>${lunbo[index].title}</div>`
    //  })
    p.forEach((item, index) => {
      item.innerHTML = `<div>${lunbo[index].title}</div>`;
    });
    
  }
  render() {
    const { current } = this.state;
    return (
      <div
        style={{
          width: "100%",
          height: "100%",
          position: "relative",
          padding: "145px 0",
          Zindex: 10,
        }}
        id="home_swiper"
      >
        <Swiper
          {...config}
          style={{ position: "static" }}
        >
          {lunbo.map((item, i) => (
            <SwiperSlide
              key={i}
              className="solid"
              data-item={JSON.stringify(item)}
            >
              <img style={styles.img} src={item.img} />
              <div style={styles.rightContent}>
                <div style={styles.subTitle}>
                  <span>{item.title}</span>
                </div>
                <div
                  style={{
                    textAlign: "left",
                    width: "100%",
                    height: "85px",
                    marginBottom: 20,
                    whiteSpace: "normal",
                    wordBreak: "break-all",
                    overflow: "hidden",
                    fontSize:'#000',
                    opacity:0.6
                  }}
                >
                  <span>{item.content}</span>
                </div>
                <div>
                  <Link to={item.url}>
                    <span
                      style={{ textDecoration: "underline", color: "#F4AA14",fontSize:'16px' }}
                    >
                      了解详情
                    </span>
                  </Link>
                </div>
              </div>
            </SwiperSlide>
          ))}
          <div className="swiper-pagination"></div>
        </Swiper>
        {/* <Button type="detail" style={{marginTop:'107px'}}>了解详情 -></Button> */}
      </div>
    );
  }
}
const lunbo = [
  {
    title: "跨模态检索",
    content:
      "跨模态检索技术，在做线索摸排时，可使用案件线索的文本关键词，直接对案发现场及周边的视频进行跨模态快速检索，系统反馈回视频中出现的图像信息，给线索排查工作，带来无限的可能性！",
    img: require('../../assets/img/img_shouye_jishu_01.png').default,
    url: "/coreTechnique/0",
  },
  {
    title: "ReID算法",
    content:
      "ReID（行人重识别），通过人体特征目标检测、以图搜图等手段快速获取视频中的特征价值信息，支持跨摄像头跨区域快速检索嫌疑人对象，广泛适用于街道、社区、商场等各类追踪场景。我司检索识别命中率rank-1可达到95.8%，平均精确度mAP可达到94.2%，超越同类产品，处于行业领先地位。",
    img: require('../../assets/img/img_shouye_jishu_01.png').default,
    url: "/coreTechnique/1",
  },
  {
    title: "视频碰撞",
    content:
      "视频碰撞技术，针对于无照片寻找目标人物的场景。在指定时间段内对一段或多段视频进行目标解析，利用先进算法比对，碰撞出多段视频内都出现过的目标，进而筛查目标人物图像。",
    img: require('../../assets/img/img_shouye_jishu_02.png').default,
    url: "/coreTechnique/2",
  },
  {
    title: "人脸比对",
    content:
      "人脸比对技术，针对人脸1:1  / 人脸1:N / 人脸碰撞等应用场景，通过AI算法快速计算出每张人脸特征值，进行相似度比对。",
    img: require('../../assets/img/img_shouye_jishu_03.png').default,
    url: "/coreTechnique/3",
  },
  {
    title: "图像增强",
    content:
      "能够处理雾霾天气下的图像去雾、暗夜暗光场景下的图像提亮、图像细节的超分辨率成像等多种图像优化处理，可实现对模糊图像的优化处理，获取图像价值信息，有利支撑实战。",
    img: require('../../assets/img/img_shouye_jishu_04.png').default,
    url: "/coreTechnique/4",
  }
  
];
const styles = {
  skewReact: {
    width: 162,
    heigth: 40,
    transform: "skewX(-30deg)",
    background: "rgba(0, 0, 0, 0.2)",
    fontSize: "16px",
    fontfFamily: "PingFangSC-Regular, PingFang SC",
    fontWeight: 400,
    color: "#FFFFFF",
    lineHeight: "44px",
    textAlign: "center",
    margin: "0 4px",
    cursor: "pointer",
  },
  active: {
    width: 162,
    heigth: 40,
    transform: "skewX(-30deg)",
    fontSize: "16px",
    fontfFamily: "PingFangSC-Regular, PingFang SC",
    fontWeight: 400,
    lineHeight: "44px",
    textAlign: "center",
    margin: "0 4px",
    cursor: "pointer",
    color: "#fff",
    background: "#182C54",
  },
  banner: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    marginBottom: 110,
  },
  solid: {
    width: 860,
    height: 240,
    background: "#FFFFFF",
    boxShadow: "20px 20px 60px 0px rgba(0, 0, 0, 0.19)",
    borderRadius: "233px",
    display: "inline-block",

    padding: 10,
  },
  img: {
    width: 220,
    height: 220,
    float: "left",
  },

  rightContent: {
    marginLeft: "250px",
    height: "100%",
    width: 530,
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
    alignItems: "flex-start",
  },
  subTitle: {
    lineHeight: "20px",
    fontSize: "20px",
    marginBottom: "20px",
    fontWeight: 600,
    background:
      "linear-gradient(180deg, rgba(213, 157, 34, 0) 0%, rgba(243, 175, 30, 0.2) 100%)",
  },
};
export default Simplelunbo;
